// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"24":"ad3d3ff1d0958c53","797":"e6596b86cd493f1b"}[chunkId] + ".js";
};